import { listChatSubagentRuns, listChatWorkflowRuns } from "./api";
import type { ChatSubagentRun, ChatWorkflowRun } from "./chat";

/** 取得できた一覧だけを持つ結果。null は「この一覧は取れなかった」で、空配列とは区別する。 */
export interface ChatRunsSnapshot {
	subagentRuns: ChatSubagentRun[] | null;
	workflowRuns: ChatWorkflowRun[] | null;
	/** どちらかが失敗したときの理由。両方成功なら null。 */
	failure: unknown | null;
}

/**
 * チャットの実行一覧を 2 本まとめて取得する。片方の失敗でもう片方を巻き添えにしない —
 * 束ねて待つと、成功した応答まで捨ててワークフロー側の障害でサブエージェント一覧まで凍る。
 */
export async function fetchChatRuns(
	chatId: string,
	includeWorkflows: boolean,
): Promise<ChatRunsSnapshot> {
	const [subagent, workflow] = await Promise.allSettled([
		listChatSubagentRuns(chatId),
		// 引かなかった場合は「取れなかった」と同じ null にする。空配列を返すとサーバーが 0 件と
		// 答えたのと区別できず、workflow を起動した直後に発行済みだった取得が後から着弾して
		// 一覧を消してしまう。
		includeWorkflows ? listChatWorkflowRuns(chatId) : Promise.resolve(null),
	]);
	return {
		subagentRuns: subagent.status === "fulfilled" ? subagent.value : null,
		workflowRuns: workflow.status === "fulfilled" ? workflow.value : null,
		failure:
			subagent.status === "rejected"
				? subagent.reason
				: workflow.status === "rejected"
					? workflow.reason
					: null,
	};
}
